import React, { useContext, useEffect, useState } from "react";
import { FallBackSpinner } from "../../../components/common/Spinner/FallBackSpinner/FallbackSpinner";
import {
  getUser,
  getUserClaims,
} from "../../services/authentication/authentication.service";
import {
  clearStorage,
  getItem,
} from "../../services/common/storage/storage.service";

interface IUserInfo {
  userType: number;
  userName?: string;
  name?: string;
  family?: string;
  userInfoId?: number;
  authTime?: string;
  roles: string[];
}

interface IUserClaim {
  value: string;
  type: string;
}

export interface IAuthInfo {
  token: string;
  userClaim: IUserClaim[];
  userInfo: IUserInfo;
  role: string[];
  setUserClaimState: React.Dispatch<React.SetStateAction<IUserClaim[]>>;
  setUserInfoState: React.Dispatch<React.SetStateAction<IUserInfo>>;
  setTokenState: React.Dispatch<React.SetStateAction<string>>;
  setRoleState: React.Dispatch<React.SetStateAction<string[]>>;
  isAuthenticated: () => boolean;
  resetAuthContext: () => void;
  logOut: () => void;
}

export const authContext = React.createContext<IAuthInfo | null>(null);

const initialUserInfoState: IUserInfo = {
  userType: 1,
  userName: "",
  name: "",
  authTime: "",
  family: "",
  userInfoId: 0,
  roles: ["NormalUser"],
};

const useUserAuth = () => {
  const pc = useContext(authContext);
  if (pc === null) {
    throw new Error("usePermissions Must be inside of Provider");
  }
  return pc;
};

// default initial from local-storage
const token: any =
  getItem("token") && getItem("token") !== "undefined" ? getItem("token") : "";

const currentUserInfo: any =
  getItem("userInfo") && getItem("userInfo") !== "undefined"
    ? getItem("userInfo")
    : "";
const currentUserRoles: any =
  getItem("role") && getItem("role") !== "undefined" ? getItem("role") : "";

const userInfo: any = currentUserInfo ? JSON.parse(currentUserInfo) : null;
const userRoles: any = currentUserRoles ? JSON.parse(currentUserRoles) : [];

const userClaim: any = getUserClaims() ? getUserClaims() : [];

const AuthenticationContext: React.FC = ({ children }) => {
  const [userInfoState, setUserInfoState] = useState<IUserInfo>(
    userInfo
      ? userInfo
      : {
          userType: 0,
          authTime: "",
          family: "",
          name: "",
          userInfoId: 0,
          userName: "",
          roles: ["NormalUser"],
        }
  );
  const [tokenState, setTokenState] = useState<string>(token);
  const [userClaimState, setUserClaimState] = useState<IUserClaim[]>(userClaim);
  const [roleState, setRoleState] = useState<string[]>(userRoles || []);
  const logOut = () => {
    clearStorage();
    setUserInfoState({
      userType: 0,
      authTime: "",
      family: "",
      name: "",
      userInfoId: 0,
      userName: "",
      roles: [],
    });
    setTokenState("");
    setUserClaimState([]);
    setRoleState([]);
    window.location.pathname = "/";
  };

  // const getData = async () => {
  //   try {
  //     const user = await getUser();

  //     let roles: any =
  //       getItem("role") && getItem("role") !== "undefined"
  //         ? getItem("role")
  //         : JSON.stringify(["UserReal"]);

  //     if (roles) {
  //       setRoleState(JSON.parse(roles));
  //     }

  //     const userInfo: any =
  //       getItem("userInfo") &&
  //       getItem("userInfo") !== "undefined" &&
  //       getItem("userInfo");
  //     const myUserInfo: any = JSON.parse(userInfo);

  //     if (myUserInfo) {
  //       setUserInfoState({
  //         userName: myUserInfo?.userName,
  //         name: myUserInfo?.name,
  //         family: myUserInfo?.family,
  //         authTime: user?.profile.auth_time?.toString(),
  //         userType: +myUserInfo?.userType,
  //         userInfoId: +myUserInfo?.userInfoId,
  //         roles,
  //       });
  //     }

  //     setIsLoading(false);
  //   } catch (error) {}
  // };

  // useEffect(() => {
  //   getData();
  // }, []);

  const isAuthenticated = () => {
    if (!userInfoState.userType || !userInfoState.userInfoId) {
      return false;
    }
    if (token) {
      return true;
    }

    return false;
  };

  const resetAuthContext = () => {
    setUserInfoState(initialUserInfoState);
    setTokenState("");
    setRoleState([""]);
  };

  return (
    <authContext.Provider
      value={{
        token: tokenState,
        userInfo: userInfoState,
        role: roleState,
        userClaim: userClaimState,
        setUserClaimState,
        setUserInfoState,
        setTokenState,
        setRoleState,
        isAuthenticated,
        resetAuthContext,
        logOut,
      }}
    >
      {children}
    </authContext.Provider>
  );
};

const CanClaim: React.FC<{ userClaim: IUserClaim }> = ({
  userClaim,
  children,
}) => {
  const { userClaim: allUserClaims } = useUserAuth();

  let valid = false;

  allUserClaims.forEach((item: IUserClaim) => {
    item.type === userClaim.type && item.value === userClaim.value
      ? (valid = true)
      : (valid = false);
  });

  if (valid) {
    return <>{children}</>;
  } else {
    return null;
  }
};

export { AuthenticationContext, useUserAuth, CanClaim };
